module.exports = __webpack_public_path__ + "static/ratio-city-logo-f26f91e72df1feececaa047eae98c797.png";